// Turkish (TR) - Default language
export const tr = {
  // Navigation
  home: "Ana Sayfa",
  back: "Geri",
  products: "Ürünler",
  contact: "İletişim",
  support: "Destek",
  login: "Giriş Yap",
  register: "Kayıt Ol",
  admin: "Admin",
  logout: "Çıkış",

  // Home Page
  fastDelivery: "Hızlı Teslimat",
  viewProducts: "Ürünleri Görüntüle",
  getInTouch: "İletişime Geç",

  // Products
  allProducts: "Tüm Ürünler",
  addToCart: "Sepete Ekle",
  outOfStock: "Stokta Yok",
  discount: "İndirim!",
  price: "Fiyat",
  originalPrice: "Eski Fiyat",
  quantity: "Adet",
  inStock: "Stokta",

  // Product Detail
  productDetails: "Ürün Detayları",
  weight: "Ağırlık",
  shelfLife: "Raf Ömrü",
  ingredients: "İçindekiler",
  allergens: "Alerjenler",
  aboutProduct: "Ürün Hakkında",
  youMayAlsoLike: "Bunlar da Hoşunuza Gidebilir",

  // Cart
  shoppingCart: "Alışveriş Sepeti",
  cartEmpty: "Sepetiniz boş",
  continueShopping: "Alışverişe Devam Et",
  proceedToCheckout: "Ödemeye Geç",
  removeItem: "Kaldır",
  cartEmptyDesc: "Henüz sepetinize ürün eklemediniz. Lezzetli ürünlerimizi keşfetmek için ürünler sayfamızı ziyaret edin!",
  itemsInCart: "{count} ürün sepetinizde",
  cartContents: "Sepet İçeriği",
  clearCart: "Sepeti Temizle",
  confirmClearCart: "Sepeti tamamen temizlemek istediğinizden emin misiniz?",
  orderSummary: "Sipariş Özeti",
  calculatingShipping: "Hesaplanıyor...",
  shippingCalculatedAtCheckout: "Ödeme adımında hesaplanır",

  // Checkout
  checkout: "Ödeme",
  paymentMethod: "Ödeme Yöntemi",
  firstName: "Ad",
  lastName: "Soyad",
  city: "Şehir",
  postalCode: "Posta Kodu",
  agreeTerms: "Şartları ve koşulları kabul ediyorum",
  checkoutSubtitle: "Siparişinizi tamamlamak için bilgilerinizi girin",
  guestCardOnlyNotice: "Misafir siparişlerde sadece kart ile ödeme kabul edilmektedir.",
  termsAndConditions: "Şartları ve Koşulları",
  agreeTermsAndPrivacy: "{terms} ile {privacy}'nı okudum ve kabul ediyorum.",
  qtyUnit: "adet",
  backToCart: "Sepete Dön",
  sslEncryption: "256-bit SSL Şifreleme",
  enterCityForShipping: "Şehir girin",
  orderCreationFailed: "Sipariş oluşturulamadı.",
  orderCreationError: "Sipariş oluşturulurken bir hata oluştu.",
  checkoutEmptyCartDesc: "Ödeme yapmak için önce sepetinize ürün eklemeniz gerekiyor.",
  downloading: "İndiriliyor...",
  invoiceDownloadFailed: "Fatura indirilemedi. Lütfen daha sonra tekrar deneyin.",

  // Order
  orderSuccess: "Sipariş Başarılı!",
  orderSuccessMessage: "Siparişiniz başarıyla işlendi. En kısa sürede size e-posta ile sipariş detaylarını göndereceğiz.",
  orderDetails: "Sipariş Detayları",
  orderNumber: "Sipariş No",
  date: "Tarih",
  status: "Durum",
  confirmed: "Onaylandı",
  emailConfirmation: "E-posta Onayı",
  emailConfirmationDesc: "Sipariş detaylarınızı içeren e-postayı kontrol edin",
  preparing: "Hazırlanıyor",
  preparingDesc: "Ürünleriniz özenle hazırlanıyor",
  delivery: "Teslimat",
  deliveryDesc: "Taze ürünleriniz kapınıza geliyor",
  trackOrder: "Sipariş Takip",

  // Order Tracking
  trackYourOrder: "Siparişinizi Takip Edin",
  enterOrderId: "Sipariş ID veya takip numarası girin",
  orderNotFound: "Sipariş bulunamadı",
  shippingAddress: "Teslimat Adresi",
  trackingNumber: "Takip Numarası",
  orderItems: "Sipariş İçeriği",
  orderPlaced: "Sipariş Verildi",
  processing: "İşleniyor",
  shipped: "Kargoya Verildi",
  outForDelivery: "Teslimat İçin Yola Çıktı",
  delivered: "Teslim Edildi",
  estimatedDelivery: "Tahmini Teslimat",
  downloadInvoice: "Fatura İndir",
  packagingStatus: "Paketleniyor",
  orderCancelled: "İptal Edildi",
  defaultProductName: "Değerli Lezzet",
  defaultCustomerName: "Sayın Müşterimiz",
  orderFetchError: "Sipariş bilgisi alınırken bir hata oluştu.",
  awaitingDate: "Bekleniyor",
  fetchingOrder: "Siparişiniz Getiriliyor...",
  deliveryJourney: "Teslimat Yolculuğu",
  packageTrackingTitle: "Paketiniz {highlight}",
  packageTrackingTitleHighlight: "Güvende mi?",
  trackOrderInstructions: "Sipariş numaranızı yukarıdaki alana girerek paketinizin durumunu anlık olarak görebilirsiniz.",
  getSupport: "Destek Al",
  backToStore: "Mağazaya Dön",
  orderHistoryLabel: "Sipariş Geçmişi",
  deliveryInfoTitle: "Teslimat Bilgileri",
  needHelpTitle: "Yardıma mı ihtiyacınız var?",
  whatsappHelpText: "Siparişinizle ilgili bize her zaman WhatsApp üzerinden yazabilirsiniz.",
  customerService: "Müşteri Hizmetleri",
  notSatisfiedTitle: "Ürününüzden memnun kalmadınız mı?",
  returnExchangeText: "İade veya değişim talebinde bulunabilirsiniz.",
  createReturnRequest: "İade Talebi Oluştur",

  // Cash on Delivery Options
  deliveryOptionsLoadError: "Teslimat seçenekleri yüklenirken bir hata oluştu.",
  loadingDeliveryOptions: "Teslimat seçenekleri yükleniyor...",
  codTitle: "Kapıda Ödeme & Teslimat Seçenekleri",
  noDeliveryScheduleForCity: "Bu şehir için şu anda teslimat programı bulunmuyor.",
  tryDifferentMethodOrLater: "Lütfen farklı bir teslimat yöntemi seçin veya daha sonra tekrar deneyin.",
  currentMonthLabel: "Mevcut Ay",
  codAvailable: "Müsait",
  moreDatesAvailable: "+{count} tarih daha mevcut",
  nextMonthLabel: "Gelecek Ay",
  codScheduled: "Planlanmış",
  currentMonthScheduleCompleted: "Mevcut ay teslimat programı tamamlandı",
  currentMonthPassedNextAvailable: "Bu ay için planlanan teslimat tarihleri geçti. Gelecek ay teslimat edilebilir.",
  selectedDeliveryDateLabel: "Seçilen Teslimat Tarihi",
  activeDeliverySchedules: "Aktif Teslimat Programları",

  // Payment Methods
  payWithCard: "Kart ile Öde",
  cashOnDeliveryLabel: "Kapıda Ödeme",
  selectPaymentMethod: "Ödeme Yöntemi Seçin",
  noActivePaymentMethod: "Şu an aktif ödeme yöntemi bulunmuyor. Lütfen yönetici ile iletişime geçin.",
  paymentProcessingError: "Ödeme sırasında bir hata oluştu.",
  pay: "Öde",
  redirecting: "Yönlendiriliyor...",
  payWithMethod: "{method} ile Öde",
  paymentAmountLabel: "Ödeme tutarı",
  redirectingToPaymentPage: "Ödeme sayfasına yönlendirileceksiniz.",
  mollieStartFailed: "Mollie ödemesi başlatılamadı.",
  cashOnDeliveryDesc: "Teslimat sırasında nakit veya kart ile ödeme yapabilirsiniz.",
  confirmOrder: "Siparişi Onayla",
  orderWithPaymentObligation: "Ödeme Yükümlülüğüyle Sipariş Ver",
  cardNotStoredDesc: "Kart bilgileriniz güvenliğiniz için sistemimizde saklanmaz. Her sipariş sırasında ödemeniz Stripe veya Mollie üzerinden güvenli biçimde işlenir.",
  calculatingDeliveryDates: "Teslimat tarihleri hesaplanıyor...",
  noDeliveryScheduleContact: "\"{city}\" için henüz teslimat programı tanımlanmamış. Lütfen bize ulaşın.",
  deliveryInfoLabel: "Teslimat Bilgisi",
  deliveryDaysLabel: "Teslimat günleri:",
  upcomingDeliveryDates: "Yaklaşan Teslimat Tarihleri",
  freeShippingOverAmount: "{amount} üzeri ücretsiz",
  selectCityLabel: "Şehir Seç",
  cityListLoadFailed: "Şehir listesi yüklenemedi",
  paymentVerifying: "Ödeme Doğrulanıyor",
  paymentVerifyingDesc: "Ödemeniz kontrol ediliyor, lütfen bekleyin...",
  paymentSuccessful: "Ödeme Başarılı!",
  orderReceivedRedirecting: "Siparişiniz alındı, yönlendiriliyorsunuz...",
  customerReviews: "Müşteri Yorumları",
  writeReview: "Yorum Yaz",
  reviewTitle: "Yorum Başlığı",
  yourReview: "Yorumunuz",
  yourName: "Adınız",
  yourFullName: "Adınız Soyadınız",
  submitReview: "Yorum Gönder",
  verified: "Doğrulanmış",
  wasHelpful: "Bu yorum faydalı mıydı?",
  yes: "Evet",
  no: "Hayır",
  noReviewsYet: "Henüz yorum yok",
  beFirstToReview: "Bu ürün için ilk yorumu siz yazın!",
  writeFirstReview: "İlk Yorumu Yaz",

  // Profile  
  personalInfo: "Kişisel Bilgiler",
  cancel: "İptal",
  profileUpdated: "Profil başarıyla güncellendi!",

  // Email Notifications
  emailNotifications: "E-posta Bildirimleri",
  language: "Dil",
  orderConfirmations: "Sipariş Onayları",
  orderConfirmationsDesc: "Sipariş verdiğinizde onay e-postası alın",
  shippingUpdates: "Kargo Güncellemeleri",
  shippingUpdatesDesc: "Siparişiniz kargoya verildiğinde bildirim alın",
  deliveryNotifications: "Teslimat Bildirimleri",
  deliveryNotificationsDesc: "Siparişiniz teslim edildiğinde bildirim alın",
  marketingEmails: "Pazarlama E-postaları",
  marketingEmailsDesc: "Promosyon e-postaları ve özel teklifler alın",
  newsletter: "Bülten",
  newsletterDesc: "En son haberler ve ürünler hakkında güncel kalın",
  productRecommendations: "Ürün Önerileri",
  productRecommendationsDesc: "Kişiselleştirilmiş ürün önerileri alın",
  reviewReminders: "Yorum Hatırlatmaları",
  reviewRemindersDesc: "Satın aldığınız ürünleri değerlendirmeniz için hatırlatma",
  specialOffers: "Özel Teklifler",
  specialOffersDesc: "Özel teklifler ve indirimler",
  birthdayOffers: "Doğum Günü Teklifleri",
  birthdayOffersDesc: "Doğum gününüzde özel teklifler",
  emailFrequency: "E-posta Sıklığı",
  emailFrequencyDesc: "Inbox'ınızı saygı duyarız ve sadece ilgili e-postalar göndeririz. Bu ayarları istediğiniz zaman değiştirebilirsiniz.",

  // Wishlist
  wishlist: "Favoriler",
  myWishlist: "Favorilerim",
  wishlistEmpty: "Favori Listeniz Boş",
  wishlistEmptyDesc: "Henüz favori listenize ürün eklemediniz. Beğendiğiniz ürünleri kalp ikonuna tıklayarak favorilerinize ekleyebilirsiniz.",
  removeFromWishlist: "Favorilerden Çıkar",
  wishlistItemsCount: "Favori listenizde {count} ürün var",
  addAllToCart: "Tümünü Sepete Ekle",
  clearWishlist: "Favorileri Temizle",
  clearWishlistConfirm: "Favori listenizi temizlemek istediğinizden emin misiniz?",
  totalValue: "Toplam Değer",
  addedToCart: "sepete eklendi!",
  allItemsAddedToCart: "Tüm ürünler sepete eklendi!",
  startShopping: "Alışverişe Başla",
  lastUpdatedLabel: "Son Güncelleme",

  // Coupons
  haveCoupon: "Kupon Kodunuz Var mı?",
  enterCouponCode: "Kupon kodunu girin",
  apply: "Uygula",
  couponApplied: "Kupon Uygulandı",
  invalidCoupon: "Geçersiz kupon kodu",
  couponExpired: "Kupon süresi dolmuş",
  minPurchaseNotMet: "Minimum alışveriş tutarı karşılanmadı",
  couponError: "Kupon hatası",
  availableCoupons: "Kullanılabilir Kuponlar",
  couponCopied: "Kupon kopyalandı",
  validUntil: "Geçerlilik",
  minPurchase: "Min. Alışveriş",
  copy: "Kopyala",
  freeShipping: "Ücretsiz Kargo",

  // Live Support
  online: "Çevrimiçi",
  offline: "Çevrimdışı",

  // Support Page
  emailSupportDesc: "24 saat içinde yanıt",
  sendEmail: "E-posta Gönder",
  whatsappSupport: "WhatsApp Desteği",
  whatsappSupportDesc: "Hızlı mesajlaşma",
  whatsappGreetingMessage: "Merhaba! Destek almak istiyorum.",
  messageWhatsApp: "WhatsApp'ta Mesaj",
  frequentlyAskedQuestions: "Sık Sorulan Sorular",

  // Social Media
  share: "Paylaş",
  linkCopied: "Link kopyalandı!",
  followUsOn: "Bizi takip edin",


  // Search & Filters
  searchPlaceholder: "Ürün ara...",
  suggestions: "Öneriler",
  recentSearches: "Son Aramalar",
  filters: "Filtreler",
  category: "Kategori",
  subcategory: "Alt Kategori",
  allSubcategories: "Tüm Alt Kategoriler",
  priceRange: "Fiyat Aralığı",
  newProducts: "Yeni Ürünler",
  recommendedForYou: "Sizin İçin Önerilenler",
  popular: "Popüler",
  onSale: "İndirimde",
  brand: "Marka",
  origin: "Menşei",
  sortBy: "Sırala",
  relevance: "İlgililik",
  priceLow: "Fiyat (Düşük-Yüksek)",
  priceHigh: "Fiyat (Yüksek-Düşük)",
  rating: "Puan",
  newest: "En Yeni",
  name: "İsim",
  searching: "Aranıyor",
  showAllProducts: "Tüm Ürünleri Göster",

  // Inventory Management
  overview: "Genel Bakış",
  alerts: "Uyarılar",
  product: "Ürün",
  minStock: "Min. Stok",
  unknown: "Bilinmiyor",

  // Admin Dashboard
  orders: "Siparişler",
  customers: "Müşteriler",
  reviews: "Yorumlar",
  reports: "Raporlar",
  settings: "Ayarlar",
  totalOrders: "Toplam Sipariş",
  totalCustomers: "Toplam Müşteri",

  // Analytics & Reporting
  analyticsDashboard: "Analitik Dashboard",
  businessOverview: "İşletme Genel Bakış",
  salesAnalytics: "Satış Analitikleri",
  customerAnalytics: "Müşteri Analitikleri",
  inventoryAnalytics: "Stok Analitikleri",
  marketingAnalytics: "Pazarlama Analitikleri",
  reportsAndExports: "Raporlar ve Dışa Aktarma",
  last7Days: "Son 7 Gün",
  last30Days: "Son 30 Gün",
  last90Days: "Son 90 Gün",
  lastYear: "Son Yıl",
  dateRange: "Tarih Aralığı",
  vsLastMonth: "Geçen Aya Göre",
  totalRevenue: "Toplam Gelir",
  averageOrderValue: "Ortalama Sipariş Değeri",
  conversionRate: "Dönüşüm Oranı",
  newCustomers: "Yeni Müşteriler",
  averageCustomerValue: "Ortalama Müşteri Değeri",
  turnoverRate: "Devir Hızı",
  averageStockDays: "Ortalama Stok Günleri",
  totalVisitors: "Toplam Ziyaretçi",
  uniqueVisitors: "Benzersiz Ziyaretçi",
  bounceRate: "Çıkış Oranı",
  avgSessionDuration: "Ort. Oturum Süresi",
  revenueTrend: "Gelir Trendi",
  revenueByCategory: "Kategoriye Göre Gelir",
  customerSegments: "Müşteri Segmentleri",
  trafficSources: "Trafik Kaynakları",
  conversionFunnel: "Dönüşüm Hunisi",
  topMovingProducts: "En Çok Satan Ürünler",
  unitsSold: "Satılan Birim",
  generateReport: "Rapor Oluştur",
  exportData: "Veri Dışa Aktar",
  reportType: "Rapor Türü",
  salesReport: "Satış Raporu",
  customerReport: "Müşteri Raporu",
  inventoryReport: "Stok Raporu",
  marketingReport: "Pazarlama Raporu",
  comprehensiveReport: "Kapsamlı Rapor",
  generatePDF: "PDF Oluştur",
  generateExcel: "Excel Oluştur",
  exportSalesData: "Satış Verilerini Dışa Aktar",
  exportCustomerData: "Müşteri Verilerini Dışa Aktar",
  exportInventoryData: "Stok Verilerini Dışa Aktar",
  exportMarketingData: "Pazarlama Verilerini Dışa Aktar",

  // Navigation
  confirmLogout: "Çıkış yapmak istediğinizden emin misiniz?",
  collections: "Koleksiyonlar",
  collectionsMenuTitleLine1: "Anadolu'dan",
  collectionsMenuTitleHighlight: "Özel Keşifler",
  collectionsMenuSubtitle: "Geleneksel Tarifler, Modern Sunumlar",
  viewAllCollections: "Tüm Koleksiyonu Gör",
  discover: "Keşfet",
  sustainableShipping: "Sürdürülebilir Kargo",
  allNaturalContent: "%100 Doğal İçerik",
  allCategoryProducts: "Tüm {category} Ürünleri",
  logoAlt: "Logo",

  // FAQ
  faqQuestion1: "Siparişimi nasıl takip edebilirim?",
  faqAnswer1: "Siparişinizi takip etmek için 'Sipariş Takip' sayfasından sipariş numaranızı girebilir veya e-posta ile gönderilen takip linkini kullanabilirsiniz.",
  faqQuestion2: "Kargo süresi ne kadar?",
  faqAnswer2: "Belçika ve Hollanda'ya kargo süremiz 3-5 iş günüdür. Özel durumlar için müşteri hizmetlerimizle iletişime geçebilirsiniz.",
  faqQuestion3: "Hangi ödeme yöntemlerini kabul ediyorsunuz?",
  faqAnswer3: "Kredi kartı, banka havalesi ve PayPal ile ödeme yapabilirsiniz. Tüm ödemeler güvenli şekilde işlenir.",
  faqQuestion4: "İade politikası nedir?",
  faqAnswer4: "Ürünlerinizi teslim aldığınız tarihten itibaren 2 gün içinde destek ekibimizle iletişime geçebilirsiniz.",
  faqQuestion5: "Ürünleriniz doğal mı?",
  faqAnswer5: "Evet, tüm ürünlerimiz doğal malzemelerle hazırlanmıştır. Hiçbir koruyucu madde veya yapay katkı maddesi içermez.",
  faqQuestion6: "Nasıl üye olabilirim?",
  faqAnswer6: "Sağ üst köşedeki 'Kayıt Ol' butonuna tıklayarak ücretsiz hesap oluşturabilirsiniz. E-posta adresiniz ve şifrenizle kolayca kayıt olabilirsiniz.",
  faqQuestion7: "Ürünleriniz helal sertifikalı mı?",
  faqAnswer7: "Evet, tüm ürünlerimiz helal sertifikalıdır. Üretim süreçlerimizde helal standartlarına uygunluk sağlanır ve düzenli olarak denetlenir. Sertifikalarımızı müşterilerimizle paylaşmaktan memnuniyet duyarız.",
  faqQuestion8: "Dondurulmuş ürünlerin besin değeri korunuyor mu?",
  faqAnswer8: "Evet, hızlı dondurma teknolojisi kullanarak ürünlerimizin besin değerini ve lezzetini koruyoruz. Bu sayede taze hazırlanmış gibi lezzet alırsınız.",
  faqQuestion9: "Ürünlerinizde katkı maddesi var mı?",
  faqAnswer9: "Hayır, ürünlerimizde yapay katkı maddesi kullanmıyoruz. Geleneksel yöntemlerle, doğal malzemelerle hazırlanan ürünlerimiz hem sağlıklı hem de lezzetlidir.",

  // About Page
  aboutUs: "Köklerimiz ve Mirasımız",
  ourStory: "Hikayemiz",
  ourStoryText: "Türk Mutfağı, sadece bir e-ticaret platformu değil; Bereketli Hilal'in ortasından, Mezopotamya'nın kalbinden gelen bir lezzet köprüsüdür. Hikayemiz, sabahın ilk ışıklarıyla uyanan bakır kazanların tıkırtısında saklı.",
  ourMissionText: "Amacımız, bugün modernize edilmiş dünyada kaybolmaya yüz tutmuş gerçek \"sohbet lezzetlerini\" en saf haliyle Avrupa'daki sofralara taşımak. Hiçbir katkı maddesi kullanmadan, tıpkı dedelerimizin yaptığı gibi...",
  halalCertified: "Helal Sertifikalı",
  ourValues: "Sarsılmaz İlkelerimiz",
  traditionalCraftsmanship: "Usta Elleri",
  traditionalCraftsmanshipText: "Her baklava yufkasını ışık geçecek kadar incelten, lokumun kıvamını sadece göz kararıyla bilen nesillerin tecrübesi.",
  qualityAssurance: "Saf Ham Madde",
  qualityAssuranceText: "Sadece mevsiminde toplanan Antep fıstıkları, taş değirmende ezilen susamlar ve yayla çiçeklerinden süzülen ham ballar.",
  halalCertifiedValue: "Helal Sertifikası",
  halalCertifiedValueText: "İnançlarınıza ve değerlerinize %100 saygı.",
  followUsText: "Sosyal medya hesaplarımızdan güncel haberlerimizi takip edebilir, yeni ürünlerimizden haberdar olabilirsiniz.",
  ourProductionProcess: "Üretim Felsefemiz",
  freezingTechnology: "Tazelik Zinciri",
  freezingTechnologyText: "Lezzeti dondurmadan, en doğal haliyle saklayan özel paketleme ve hızlı teslimat ağımızla kapınızda.",
  qualityAndHygiene: "Şeffaf Kalite",
  qualityAndHygieneText: "Üretimin her aşamasında hijyen ve yüksek standartlar.",
  globalAccess: "Global Erişim",
  globalAccessText: "Anadolu lezzetini tüm dünyaya ulaştırma vizyonu.",
  followUsOnSocialMedia: "Hikayemizi Instagram'da İzleyin",
  followUsOnSocialMediaText: "Siz de Bu Hikayeye Ortak Olun",
  aboutHeroTagline: "Gelenekten Geleceğe",
  aboutHeroTitlePrefix: "Anadolu'nun",
  aboutHeroTitleHighlight: "Kadim Hikayesi",
  aboutHeroQuote: "Toprağın bereketiyle yoğrulan, ateşle olgunlaşan ve ustaların ellerinde sanata dönüşen bin yıllık lezzet mirası.",
  aboutHeritageTitlePrefix: "Bin Yıllık",
  aboutHeritageTitleHighlight: "Ateşin Ritmi",
  aboutNaturalContentLabel: "Doğal İçerik",
  aboutTraditionalRecipeLabel: "Geleneksel Reçete",
  aboutCraftsmanshipTitle: "Sanatçı Titizliği, Anadolu Sabrı",
  aboutValuesTitlePrefix: "Bizim İçin",
  aboutValuesTitleHighlight: "Kutsal Emanetler",

  // Contact Page
  contactUs: "İletişim",
  contactDescription: "Bizimle iletişime geçin. Sorularınızı yanıtlamaktan ve size yardımcı olmaktan memnuniyet duyarız.",
  contactForm: "İletişim Formu",
  contactFormDescription: "Aşağıdaki formu doldurarak bizimle iletişime geçebilirsiniz. En kısa sürede size dönüş yapacağız.",
  subject: "Konu",
  yourMessage: "Mesajınız",
  country: "Ülke",
  address: "Adres",
  phone: "Telefon",
  email: "E-posta",
  categoryGeneral: "Genel",
  categoryOrder: "Sipariş",
  categoryProduct: "Ürün",
  categoryPayment: "Ödeme",
  categoryShipping: "Kargo",
  categoryTechnical: "Teknik",
  categoryComplaint: "Şikayet",
  categorySuggestion: "Öneri",
  priorityLabel: "Öncelik",
  priorityLow: "Düşük",
  priorityMedium: "Orta",
  priorityHigh: "Yüksek",
  priorityUrgent: "Acil",
  selectSubject: "Konu seçin",
  subjectInfo: "Bilgi",
  subjectOther: "Diğer",
  namePlaceholder: "Adınız ve soyadınız",
  emailPlaceholder: "ornek@email.com",
  phonePlaceholder: "+32 555 123 456",
  messagePlaceholder: "Mesajınızı buraya yazın...",
  createSupportTicket: "Destek Talebi Oluştur",
  ticketCreatedSuccess: "Destek talebiniz başarıyla oluşturuldu! Talep numarası: {ticketNumber}",
  ticketCreationError: "Destek talebi oluşturulurken bir hata oluştu. Lütfen tekrar deneyin.",
  socialMedia: "Sosyal Medya",

  // Support Page
  customerSupport: "Müşteri Desteği",
  supportDescription: "Size nasıl yardımcı olabiliriz? Sorularınızı yanıtlamak ve sorunlarınızı çözmek için buradayız.",
  needMoreHelp: "Daha Fazla Yardıma mı İhtiyacınız Var?",
  contactUsDirectly: "Doğrudan bizimle iletişime geçin",

  // Footer
  followUs: "Bizi Takip Edin",
  quickLinks: "Hızlı Linkler",
  categories: "Kategoriler",
  desserts: "Tatlılar",
  contactInfo: "İletişim Bilgileri",
  allRightsReserved: "Tüm hakları saklıdır.",
  privacyPolicy: "Gizlilik Politikası",
  paymentMethods: "Ödeme Yöntemleri",
  workingHours: "Çalışma Saatleri",

  // Footer Newsletter & Trust
  worldOfPrivileges: "Ayrıcalıklar Dünyası",
  newsletterTitleLine1: "Saray Lezzetlerinden",
  newsletterTitleHighlight: "Haberdar Olun",
  newsletterDescriptionFooter: "Yeni çıkan ürünlerimizden, sınırlı üretim lezzetlerimizden ve sadece abonelerimize özel fırsatlardan ilk siz haberdar olun.",
  subscribe: "Abone Ol",
  unsubscribeNote: "* İstediğiniz zaman abonelikten çıkabilirsiniz.",
  footerBrandDescription: "Anadolu’nun bin yıllık geleneklerini, en taze malzemelerle harmanlayıp modern bir sunumla sofralarınıza getiriyoruz. Kaliteden ödün vermeyen butik üretim anlayışımızla hizmetinizdeyiz.",
  footerFavoriteFlavors: "Favori Lezzetler",
  footerCategoryDesserts: "Tatlılar & Pastalar",
  footerCategoryPastries: "Hamur İşi & Börek",
  footerCategoryMains: "Geleneksel Yemekler",
  footerCategoryIceCream: "Dondurma & Soğuk Tatlılar",
  footerCategoryGrocery: "Bakkaliye & Tahıllar",
  headOffice: "Merkez Ofis",
  customerLine: "Müşteri Hattı",
  naturalContentTrustDesc: "Ürünlerimizde hiçbir koruyucu, yapay renklendirici veya mısır şurubu kullanılmaz.",
  coldChainDelivery: "Soğuk Hava Teslimatı",
  coldChainDeliveryDesc: "Özel paketleme sistemimizle Belçika'nın her yerine 48 saat içinde taze ulaştırıyoruz.",
  securePaymentInfrastructure: "Güvenli Ödeme Alt Yapısı",
  securePaymentInfrastructureDesc: "Stripe ve Bancontact güvencesiyle tüm ödemeleriniz 256-bit SSL ile korunmaktadır.",
  distanceSalesAgreement: "Mesafeli Satış Sözleşmesi",

  // Hero Banner
  heroDefaultTitle: "Türk Mutfağı",
  heroDefaultSubtitle: "Geleneksel Türk Lezzetleri",
  heroDefaultDescription: "Usta ellerden çıkan, %100 doğal malzemelerle hazırlanan saray lezzetleri şimdi kapınızda.",
  heroDefaultButtonText: "Hemen Keşfet",
  heroDefaultBadge: "Özel Seçki",
  heroLoadingText: "Saray Mutfağı Hazırlanıyor...",

  // Home Page (main hero & sections)
  homeSeoTitle: "Eticaret — Geleneksel Türk Lezzetleri",
  homeSeoDescription: "Belçika'ya teslim: baklava, börek, mantı, dondurma ve daha fazlası. Taze, dondurulmuş, kapınızda.",
  homeHeroFreeShippingBadge: "Belçika'ya Ücretsiz Teslimat — €50 Üzeri",
  homeHeroTitleLine1: "Anadolu'nun",
  homeHeroTitleHighlight: "En Taze",
  homeHeroTitleSuffix: "Lezzetleri",
  homeHeroDescription: "Baklava, börek, mantı, dondurma — dondurulmuş ve taze. Evinize kadar.",
  promoFreeShippingOver50: "€50 Üzeri Ücretsiz Kargo",
  promoFrozenFreshDelivery: "Dondurulmuş — Taze Teslimat",
  promoNaturalIngredient: "Doğal Malzeme",
  promoSecurePayment: "Güvenli Ödeme",
  featuredProductsTitle: "Öne Çıkan Ürünler",
  viewAll: "Tümü",
  campaignsTitle: "Kampanyalar",
  campaignsBadge: "Sınırlı Süre",
  campaignsSubtitle: "Seçili ürünlerde indirim fırsatları",
  viewAllCampaigns: "Tüm Kampanyalar",
  campaignsSaving: "tasarruf",
  campaignsEmpty: "Şu anda aktif bir paket kampanya bulunmuyor.",
  collectionLabel: "Koleksiyon",
  whyEticaret: "Neden Eticaret?",
  whyEticaretSubtitle: "Sizlere En İyisini Sunuyoruz",
  whyFrozenFreshTitle: "Dondurulmuş Taze",
  whyFrozenFreshDesc: "Ürünlerimiz, annelerin elinden çıkan en taze tariflerle hazırlanır ve hemen dondurulur. Bu şekilde, hem lezzeti hem de besin değerini kaybetmeden evinizde bulunur. Donma süreci, mikroorganizmaların gelişimini durdurarak ürünün uzun süre taze kalmasını sağlar.",
  whyBelgiumWideTitle: "Belçika Geneli",
  whyBelgiumWideDesc: "Siparişiniz €50 ve üzeri olduğunda, Belçika'nın her yerine ücretsiz teslimat. Hızlı ve güvenli kargo sistemi ile ürününüz en kısa sürede kapınızda olur. Her sipariş, izlenim ve takip numarası ile takip edilebilir.",
  whyAllNaturalTitle: "100% Doğal",
  whyAllNaturalDesc: "Tüm ürünlerimiz katkısız, doğal malzemelerle hazırlanır. Koruyucu, renklendirici veya yapay tatlandırıcı kullanmayız. Geleneksel tariflerimizle, annelerin evde yaptığı gibi, saflığın ve lezzetin bir arada olduğu ürünleri size sunuyoruz.",
  whySecurePaymentTitle: "Güvenli Ödeme",
  whySecurePaymentDesc: "Kapıda ödeme, kart ile ödeme veya Stripe/Mollie ile güvenli online ödeme seçenekleri sunuyoruz. Tüm işlemler SSL şifrelemesi ile korunur.",
  ctaDiscoverAllProducts: "Tüm Ürünleri Keşfet",
  ctaProductCountDesc: "31 geleneksel ürün, kapınıza kadar teslimat",

  // Common
  loading: "Yükleniyor...",
  connectionRestored: "Bağlantı yeniden sağlandı!",
  noInternetConnection: "İnternet bağlantısı yok",
  cartTooltip: "Sepetim ({count} ürün)",
  skipToMainContent: "Ana içeriğe geç",
  error: "Hata",
  success: "Başarılı",
  save: "Kaydet",
  edit: "Düzenle",
  add: "Ekle",
  view: "Görüntüle",
  submit: "Gönder",
  total: "Toplam",
  subtotal: "Ara Toplam",
  tax: "Vergi",
  shipping: "Kargo",
  discountAmount: "İndirim",
  free: "Ücretsiz",
  cookiePolicy: "Çerez Politikası",
  termsOfUse: "Kullanım Şartları",
  cookieUsageTitle: "Çerez Kullanımı",
  cookieUsageDescPrefix: "Sitemizi kullanarak, web sitemizin performansını iyileştirmek ve size daha iyi hizmet sunmak için çerezler kullanıyoruz. Detaylı bilgi için lütfen",
  cookieUsageDescSuffix: "okuyunuz.",
  onlyNecessary: "Sadece Gerekli",
  acceptAll: "Tümünü Kabul Et",
  cookiePreferencesTitle: "Çerez Tercihleri",
  cookiePreferencesDesc: "Hangi çerezleri kabul etmek istediğinizi seçebilirsiniz",
  necessaryCookiesTitle: "Zorunlu Çerezler",
  alwaysActive: "Her zaman aktif",
  necessaryCookiesDesc: "Web sitesinin temel işlevlerini çalıştırmak için gereklidir. Devre dışı bırakılamazlar.",
  performanceCookiesTitle: "Performans Çerezleri",
  performanceCookiesDesc: "Web sitesi performansını ve kullanıcı deneyimini analiz etmek için kullanılır.",
  examplesLabel: "Örnekler",
  functionalCookiesTitle: "İşlevsellik Çerezleri",
  functionalCookiesDesc: "Tercihlerinizi hatırlamak ve kişiselleştirilmiş deneyim sunmak için kullanılır.",
  functionalCookiesExamples: "Dil tercihleri, bölge ayarları",
  marketingCookiesTitle: "Pazarlama Çerezleri",
  marketingCookiesDesc: "Size daha uygun reklamlar göstermek ve pazarlama analizi yapmak için kullanılır.",
  saveMyPreferences: "Tercihlerimi Kaydet",
  
  // Email Verification
  emailVerification: "E-posta Doğrulama",
  emailVerificationRequired: "E-posta Doğrulama Gerekli",
  emailVerificationMessage: "E-posta adresinizi doğrulamak için {email} adresine gönderilen doğrulama linkine tıklayın.",
  emailVerifiedSuccessfully: "E-posta Başarıyla Doğrulandı",
  emailVerifiedMessage: "E-posta adresiniz başarıyla doğrulandı. Artık tüm özelliklerden yararlanabilirsiniz.",
  emailVerificationFailed: "E-posta Doğrulama Başarısız",
  emailVerificationFailedMessage: "E-posta doğrulama işlemi başarısız oldu. Lütfen tekrar deneyin.",
  checkYourEmail: "E-postanızı Kontrol Edin",
  emailVerificationInstructions: "E-posta adresinize gönderilen doğrulama linkine tıklayarak hesabınızı doğrulayın.",
  resendVerificationEmail: "Doğrulama E-postasını Tekrar Gönder",
  resendVerificationDescription: "E-posta adresinize doğrulama e-postası göndermek için aşağıdaki formu doldurun.",
  sendVerificationEmail: "Doğrulama E-postası Gönder",
  verifyingEmail: "E-posta doğrulanıyor...",
  verificationStatusCheckFailed: "E-posta doğrulama durumu kontrol edilemedi",
  verificationEmailSent: "Doğrulama e-postası gönderildi",
  verificationEmailSendFailed: "E-posta gönderilemedi",
  pleaseWaitSeconds: "Lütfen {seconds} saniye bekleyin",
  continueToProfile: "Profile Devam Et",
  backToProfile: "Profile Dön",
  backToHome: "Ana Sayfaya Dön",
  resendIn: "Tekrar gönder",
  sending: "Gönderiliyor...",
  dismiss: "Kapat",
  needHelp: "Yardıma mı ihtiyacınız var?",
  didntReceiveEmail: "E-posta almadınız mı?",
  checkSpamFolder: "Spam klasörünüzü kontrol edin ve e-postanın spam olarak işaretlenmediğinden emin olun.",
  wrongEmailAddress: "Yanlış e-posta adresi?",
  contactSupportMessage: "Destek ekibimizle iletişime geçin.",
  verificationLinkExpired: "Doğrulama linki süresi dolmuş?",
  requestNewVerification: "Yeni bir doğrulama e-postası talep edin.",
  pleaseEnterEmail: "Lütfen e-posta adresinizi girin.",
  emailAddress: "E-posta Adresi",
  enterEmailAddress: "E-posta adresinizi girin",

  // Products Page
  anatolianCollectionLabel: "Anadolu Koleksiyonu",
  listedProducts: "Listeleniyor",
  noResultsTitle: "Kısmetimizde Bu Yokmuş",
  noResultsDescription: "Aradığınız kriterlere uygun ürün bulamadık. Lütfen filtreleri temizleyip tekrar deneyin.",

  // Product Card
  newLabel: "Yeni",
  addingToCart: "Ekleniyor...",
  quickAdd: "HIZLI EKLE",

  // Product Detail
  productNotFound: "Ürün Bulunamadı",
  productNotFoundDesc: "Aradığınız ürün mevcut değil veya kaldırılmış.",
  backToProducts: "Ürünlere Dön",
  selectionRequired: "* Seçiniz",
  lastUnitsLeft: "(Son {count} adet)",
  selectVariant: "Varyant Seçiniz",
  readReturnPolicy: "İade politikamızı buradan okuyabilirsiniz",
  codPaymentNote: "Kapıda ödeme seçilebilir, kesin onay ödeme adımında adresinize göre yapılır.",
  selectCityForDelivery: "Teslimat günlerini ve kapıda ödeme uygunluğunu görmek için üstten şehrinizi seçin.",
  productCode: "Ürün Kodu",
  nutritionalValues: "Besin Değerleri",

  // Product Filters
  filterOptionsHeading: "Seçenekler",
  reset: "Sıfırla",
  allPrefix: "TÜM",
  preferences: "Tercihler",
  doesNotContainSuffix: "İÇERMEZ",
  traditionalMethodsLine1: "Geleneksel yöntemlerle,",
  traditionalMethodsLine2: "özenle hazırlanmıştır.",

  // Product Gallery
  clickToCloseZoom: "Yakınlaştırmayı kapatmak için tıklayın",
  zoomOut: "Uzaklaştır",
  zoomIn: "Yakınlaştır",

  // Product Reviews
  fillRequiredFields: "Lütfen tüm zorunlu alanları doldurun.",
  reviewSubmittedPendingApproval: "Yorumunuz incelemeye alındı, onaylandıktan sonra yayınlanacak.",
  reviewSubmitFailed: "Yorum gönderilemedi. Lütfen tekrar deneyin.",
  outOf5: "5 üzerinden",
  basedOnReviews: "{count} yoruma dayanıyor",
  summarizeExperience: "Deneyiminizi özetleyin",
  tellUsExperience: "Bu ürünle ilgili deneyiminizi bizimle paylaşın",

  // Login Page
  welcomeBack: "Hoş Geldiniz",
  loginSubtitle: "Hesabınıza giriş yapın",
  exampleEmailPlaceholder: "ornek@email.com",
  password: "Şifre",
  enterPasswordPlaceholder: "Şifrenizi girin",
  rememberMe: "Beni hatırla",
  forgotPasswordLink: "Şifremi unuttum",
  loggingIn: "Giriş Yapılıyor...",
  or: "veya",
  continueWithGoogle: "Google ile Giriş Yap",
  dontHaveAccount: "Hesabınız yok mu?",
  signUpNow: "Kayıt olun",
  loginErrorGeneric: "Giriş sırasında bir hata oluştu!",

  // Register Page
  registerSubtitle: "Türk Mutfağı ailesine katılın",
  firstNameRequired: "Ad alanı zorunludur",
  lastNameRequired: "Soyad alanı zorunludur",
  emailRequired: "E-posta alanı zorunludur",
  invalidEmail: "Geçerli bir e-posta adresi girin",
  passwordRequired: "Şifre alanı zorunludur",
  passwordMinLength: "Şifre en az 6 karakter olmalıdır",
  passwordsDoNotMatch: "Şifreler eşleşmiyor",
  cityRequired: "Şehir seçimi zorunludur",
  agreeTermsRequired: "Şartları ve koşulları kabul etmelisiniz",
  registerErrorGeneric: "Kayıt sırasında bir hata oluştu!",
  firstNamePlaceholder: "Adınız",
  lastNamePlaceholder: "Soyadınız",
  phonePlaceholderExample: "0555 123 45 67",
  cityDeliveryHelperText: "Kapıda ödeme uygunluğu ve teslimat günlerini gösterebilmemiz için gereklidir.",
  passwordMinCharsPlaceholder: "En az 6 karakter",
  confirmPassword: "Şifre Tekrar",
  confirmPasswordPlaceholder: "Şifrenizi tekrar girin",
  wantMarketingEmails: "Kampanya ve yenilikler hakkında e-posta almak istiyorum.",
  registering: "Kayıt Olunuyor...",
  registerWithGoogle: "Google ile Kayıt Ol",
  alreadyHaveAccount: "Zaten hesabınız var mı?",
  loginNow: "Giriş yapın",

  // Forgot / Reset Password
  forgotPasswordTitle: "Şifremi Unuttum",
  forgotPasswordDescription: "E-posta adresinizi girin, sıfırlama bağlantısı gönderelim.",
  resetLinkSentDefault: "Sıfırlama bağlantısı gönderildi.",
  genericErrorRetry: "Bir hata oluştu. Lütfen tekrar deneyin.",
  checkSpamReminder: "Spam klasörünüzü de kontrol etmeyi unutmayın.",
  sendResetLink: "Sıfırlama Bağlantısı Gönder",
  backToLoginLink: "Girişe Dön",
  invalidLinkTitle: "Geçersiz Bağlantı",
  invalidLinkDesc: "Şifre sıfırlama bağlantısı eksik veya hatalı.",
  requestNewLink: "Yeni bağlantı talep et",
  setNewPasswordTitle: "Yeni Şifre Belirle",
  minCharsHint: "En az 6 karakter kullanın.",
  passwordResetSuccessDefault: "Şifreniz başarıyla sıfırlandı.",
  invalidOrExpiredLink: "Geçersiz veya süresi dolmuş bağlantı.",
  redirectingToLogin: "Giriş sayfasına yönlendiriliyorsunuz...",
  newPassword: "Yeni Şifre",
  saving: "Kaydediliyor...",
  resetPasswordButton: "Şifremi Sıfırla",

  // OAuth Callback
  invalidLoginLink: "Giriş bağlantısı geçersiz.",
  loginFailedGeneric: "Giriş başarısız oldu.",
  loggingInEllipsis: "Giriş yapılıyor…",

  // Profile Page
  myProfile: "Profilim",
  manageAccountInfo: "Hesap bilgilerinizi yönetin",
  myOrders: "Siparişlerim",
  security: "Güvenlik",
  memberSince: "Üye olma tarihi",
  favoriteProducts: "Favori Ürün",
  averageRating: "Ortalama Puan",
  itemsCountSuffix: "ürün",
  details: "Detaylar",
  noOrdersYet: "Henüz sipariş vermediniz",
  discoverProductsForFirstOrder: "İlk siparişinizi vermek için ürünlerimizi keşfedin",
  myFavoriteProducts: "Favori Ürünlerim",
  noFavoritesYet: "Henüz favori ürününüz yok",
  addFavoritesHint: "Beğendiğiniz ürünleri favorilerinize ekleyin",
  exploreProducts: "Ürünleri Keşfet",
  securitySettings: "Güvenlik Ayarları",
  changePassword: "Şifre Değiştir",
  lastPasswordChange: "Son değişiklik: 3 ay önce",
  changeAction: "Değiştir",
  twoFactorAuth: "İki Faktörlü Doğrulama",
  twoFactorAuthDesc: "Hesabınızı daha güvenli hale getirin",
  enableAction: "Etkinleştir",
  sessionHistory: "Oturum Geçmişi",
  sessionHistoryDesc: "Aktif oturumları görüntüleyin",
  profileUpdateError: "Profil güncellenirken bir hata oluştu. Lütfen tekrar deneyin.",
  orderStatusPending: "beklemede",
  orderStatusConfirmed: "onaylandı",
  orderStatusProcessing: "hazırlanıyor",
  orderStatusShipped: "kargoya verildi",
  orderStatusDelivered: "teslim edildi",
  orderStatusCancelled: "iptal edildi",
  orderStatusRefunded: "iade edildi",
  orderStatusNotification: "Siparişiniz {orderNumber}: {status}",

  // Email Notification Settings
  loadPreferencesError: "Bildirim tercihleri yüklenirken hata oluştu",
  userNotFound: "Kullanıcı bilgisi bulunamadı",
  saveSettingsError: "Ayarlar güncellenirken hata oluştu",
  emailSettingsUpdated: "Email ayarları başarıyla güncellendi!",
  selectEmailsToReceive: "Hangi e-postaları almak istediğinizi seçin",
  currentFrequencyLabel: "Mevcut sıklık:",
  weeklyEmailLimitText: "Haftada maksimum 2-3 e-posta",

  // Natural Ingredients Page
  naturalIngredientsTitle: "🌿 Doğal Malzemeler",
  naturalIngredientsIntro: "Sadece en kaliteli, doğal ve taze malzemeler kullanarak hazırlıyoruz. Hiçbir koruyucu madde, yapay tatlandırıcı veya katkı maddesi bulunmaz.",
  naturalIngredients100Title: "%100 Doğal İçerikler",
  naturalIngredientsDesc1: "Türk Mutfağı olarak, ürünlerimizde sadece doğal ve organik malzemeler kullanıyoruz. Geleneksel tariflerimizi korurken, modern hijyen standartlarını da uyguluyoruz.",
  naturalIngredientsListIntro: "Her ürünümüzde kullandığımız malzemeler:",
  ingredientHoney: "Doğal bal çeşitleri",
  ingredientWalnut: "Organik ceviz ve fıstık",
  ingredientFlour: "Geleneksel un çeşitleri",
  ingredientAroma: "Doğal aromalar ve baharatlar",
  ingredientSugar: "Organik şeker ve tatlandırıcılar",
  naturalHoneyTitle: "Doğal Bal",
  naturalHoneyDesc: "Anadolu'nun en kaliteli ballarından seçtiğimiz doğal bal çeşitlerimiz",
  organicWalnutTitle: "Organik Ceviz",
  organicWalnutDesc: "Taze ceviz ve fıstık çeşitlerimizle geleneksel lezzetler",
  traditionalFlourTitle: "Geleneksel Un",
  traditionalFlourDesc: "Geleneksel yöntemlerle üretilen un çeşitlerimiz",
  qualityCertificatesTitle: "Kalite Sertifikalarımız",
  halalCertTitle: "Helal Sertifikası",
  halalCertDesc: "Tüm ürünlerimiz helal sertifikalıdır",
  organicCertTitle: "Organik Sertifika",
  organicCertDesc: "Malzemelerimiz organik sertifikalıdır",
  discoverNaturalIngredientsTitle: "Doğal Malzemelerimizi Keşfedin",
  discoverNaturalIngredientsDesc: "Doğal malzemelerle hazırlanan ürünlerimizi inceleyin ve sipariş verin",
  reviewOurProducts: "Ürünlerimizi İnceleyin",

  // Master Hands Page
  masterHandsTitle: "👩‍🍳 Usta Eller",
  masterHandsIntro: "Yılların deneyimi ve sevgiyle hazırlanan her bir ürünümüz. Geleneksel tariflerimizi modern tekniklerle harmanlayarak sunuyoruz.",
  traditionalRecipesTitle: "Geleneksel Tarifler",
  masterHandsDesc1: "Dedelerimizden, ninelerimizden gelen geleneksel tariflerimizi modern hijyen standartlarıyla harmanlayarak sunuyoruz.",
  masterHandsListIntro: "Usta ellerimizin özellikleri:",
  masterHandsFeature1: "3 kuşaktır süregelen deneyim",
  masterHandsFeature2: "Geleneksel tariflerin korunması",
  masterHandsFeature3: "Modern hijyen standartları",
  masterHandsFeature4: "Her üründe aile sıcaklığı",
  masterHandsFeature5: "Kalite kontrolünde titizlik",
  masterMehmetName: "Mehmet Usta",
  masterMehmetDesc: "30 yıllık deneyim, geleneksel baklava ustası",
  masterFatmaName: "Fatma Hanım",
  masterFatmaDesc: "Helva ve sucuk uzmanı, 25 yıllık deneyim",
  masterAliName: "Ali Usta",
  masterAliDesc: "Bal uzmanı, 20 yıllık arıcılık deneyimi",
  productionProcessTitle: "Üretim Sürecimiz",
  processStep1Title: "Malzeme Seçimi",
  processStep1Desc: "En kaliteli malzemeleri seçiyoruz",
  processStep2Title: "Geleneksel Tarif",
  processStep2Desc: "Dedelerimizin tariflerini uyguluyoruz",
  processStep3Title: "Usta Eller",
  processStep3Desc: "Deneyimli ustalarımız hazırlıyor",
  processStep4Title: "Kalite Kontrol",
  processStep4Desc: "Her ürünü kalite kontrolünden geçiriyoruz",
  discoverMasterHandsTitle: "Usta Ellerimizin Eserlerini Keşfedin",
  discoverMasterHandsDesc: "Geleneksel tariflerle hazırlanan ürünlerimizi inceleyin ve sipariş verin",

  // Fast Delivery Page
  fastDeliveryTitle: "🚚 Hızlı Teslimat",
  fastDeliveryIntro: "Taze ürünlerinizi en kısa sürede kapınıza getiriyoruz. Özel ambalajlama ve güvenli teslimat garantisi sunuyoruz.",
  fastSecureDeliveryTitle: "Hızlı ve Güvenli Teslimat",
  fastDeliveryDesc1: "Siparişlerinizi en kısa sürede kapınıza teslim ediyoruz. Taze ürünlerimizi özel ambalajlarla güvenle ulaştırıyoruz.",
  fastDeliveryListIntro: "Teslimat özelliklerimiz:",
  deliveryFeature1: "24 saat içinde teslimat",
  deliveryFeature2: "Özel soğuk zincir ambalajı",
  deliveryFeature3: "Güvenli paketleme",
  deliveryFeature4: "Kapıda ödeme seçeneği",
  deliveryFeature5: "Ücretsiz kargo (150 TL üzeri)",
  fastDeliveryCardTitle: "Hızlı Teslimat",
  fastDeliveryCardDesc: "24 saat içinde teslimat garantisi",
  specialPackagingTitle: "Özel Ambalaj",
  specialPackagingDesc: "Soğuk zincir ile güvenli paketleme",
  secureDeliveryTitle: "Güvenli Teslimat",
  secureDeliveryDesc: "Kapıda ödeme ve güvenli teslimat",
  deliveryProcessTitle: "Teslimat Sürecimiz",
  deliveryStep1Title: "Sipariş Alımı",
  deliveryStep1Desc: "Siparişinizi alıyoruz",
  deliveryStep2Title: "Hazırlık",
  deliveryStep2Desc: "Taze ürünleri hazırlıyoruz",
  deliveryStep3Title: "Paketleme",
  deliveryStep3Desc: "Özel ambalajlarla paketliyoruz",
  deliveryStep4Title: "Teslimat",
  deliveryStep4Desc: "Kapınıza teslim ediyoruz",
  deliveryAreasTitle: "Teslimat Bölgelerimiz",
  deliveryFeesTitle: "Teslimat Ücretleri",
  deliveryFeeOver50: "50 € üzeri siparişler:",
  deliveryFeeFree: "ÜCRETSİZ",
  deliveryFeeUnder50: "50 € altı siparişler:",
  deliveryFeeFast: "Hızlı teslimat (12 saat):",
  orderNowWithFastDelivery: "Hızlı Teslimat İle Sipariş Verin",
  orderNowWithFastDeliveryDesc: "Taze ürünlerinizi hızlı teslimat ile kapınıza getiriyoruz",
  orderNowButton: "Hemen Sipariş Ver",

  // Return Request Page
  reasonDamaged: "Hasarlı / Bozuk Ürün",
  reasonWrongItem: "Yanlış Ürün Gönderildi",
  reasonNotAsDescribed: "Açıklamaya Uymuyor",
  reasonChangedMind: "Fikir Değişikliği",
  orderNotFoundPeriod: "Sipariş bulunamadı.",
  orderNotFoundForNumber: "Bu sipariş numarasına ait sipariş bulunamadı.",
  returnRequestSubmitError: "Talep gönderilemedi. Lütfen tekrar deneyin.",
  returnRequestReceivedTitle: "İade Talebiniz Alındı",
  returnRequestReceivedDesc: "Talebiniz incelemeye alındı. En kısa sürede e-posta ile bilgilendirileceksiniz.",
  trackTheOrder: "Siparişi Takip Et",
  returnRequestPageDesc: "Teslim edilmiş siparişleriniz için iade talebinde bulunabilirsiniz.",
  orderInfoTitle: "Sipariş Bilgisi",
  orderNumberLabel: "Sipariş Numarası",
  orderNumberPlaceholder: "Örn: 1234567890",
  findOrderButton: "Siparişi Bul",
  orderAmountLabel: "Tutar",
  returnDeliveredOnlyNotice: "Yalnızca teslim edilmiş siparişler için iade talebi oluşturulabilir.",
  returnReasonTitle: "İade Nedeni",
  returnDescriptionLabel: "Açıklama",
  optionalFieldLabel: "(isteğe bağlı)",
  returnDescriptionPlaceholder: "İadenize dair ek bilgi paylaşın...",
  submitReturnRequest: "İade Talebini Gönder",

  // 3D Flipbook Lezzet Kataloğu
  flipbookSectionBadge: "İNTERAKTİF LEZZET DEMETİ",
  flipbookSectionTitle: "Anadolu Tadım Broşürü",
  flipbookSectionSubtitle: "Sayfaları çevirerek haftanın özel usta seçkilerini ve gizli indirim kuponlarını keşfedin.",
  flipbookTabCover: "📖 Kapak",
  flipbookCoverBadge: "2026 ÖZEL SEÇKİ",
  flipbookCoverTitle: "Anadolu Lezzetleri",
  flipbookCoverSubtitle: "Geleneksel Usta Kataloğu & Özel Fırsatlar",
  flipbookCoverDescription: "Yüzyıllık tarifler, taş değirmenler ve bakır kazanlardan sofranıza uzanan seçkin tatlar.",
  flipbookCoverTagline: "📖 Sayfayı çevirin, Anadolu’nun eşsiz lezzetlerini keşfedin",
  flipbookCoverCouponTitle: "Katalog İndirimi",
  flipbookCoverCouponDiscount: "%15 Hoş Geldin İndirimi",
  flipbookOpenCatalog: "Kataloğu Aç",
  flipbookTurnPage: "Çevir ❯",
  flipbookPrevPage: "Önceki Sayfa",
  flipbookNextPage: "Sonraki Sayfa",
  flipbookPageCount: "Sayfa",
  flipbookAutoPlayActive: "⏱️ Otomatik Çevriliyor",
  flipbookAutoPlayPaused: "⏸️ Duraklatıldı (Fare üzerinde)",
  flipbookPause: "Durdur",
  flipbookPlay: "Oynat",
  flipbookLimitedOffer: "🔥 Bu fırsat sınırlı süreliğine geçerlidir.",
  flipbookInspectAndBuy: "Hemen İncele & Satın Al",
  flipbookTastingPortion: "Tadım Porsiyonu / Özel Kutu",
  flipbookNextPageHint: "Sonraki Sayfa için Çevirin ❯",
  flipbookCatalogTitleFooter: "Anadolu İkramları Kataloğu",

  // Flipbook Örnek Sayfa İçerikleri
  flipbookCatDesserts: "Geleneksel Tatlılar",
  flipbookTagStar: "Günün Yıldızı",
  flipbookBaklavaTitle: "Havuç Dilim & Antep Baklavası",
  flipbookBaklavaSubtitle: "Gaziantep Boz Fıstığı & Hakiki Sade Yağ",
  flipbookBaklavaStory: "40 kat el açması incecik tül yufka, taş fırında meşe odunu ateşiyle pişirildi. Her dilimde çıtır bir lezzet senfonisi.",
  flipbookBaklavaFeat1: "%100 Doğal Pancar Şekeri",
  flipbookBaklavaFeat2: "Hakiki Urfa Sade Yağı",
  flipbookBaklavaFeat3: "Günlük Taze Üretim",

  flipbookCatDeli: "Kahvaltılık & Şarküteri",
  flipbookTagArtisan: "Zanaatkar Seçkisi",
  flipbookCheeseTitle: "Kars Eski Kaşarı & Gurme Peynirler",
  flipbookCheeseSubtitle: "2400m Rakımlı Yaylalardan Sofranıza",
  flipbookCheeseStory: "Yalnızca yaz aylarında serbest otlayan ineklerin sütünden, mağaralarda 12 ay boyunca geleneksel yöntemlerle olgunlaştırıldı.",
  flipbookCheeseFeat1: "12 Ay Doğal Olgunlaşma",
  flipbookCheeseFeat2: "Katkısız & Koruyucusuz",
  flipbookCheeseFeat3: "Soğuk Zincir Teslimat",

  flipbookCatNatural: "Doğal & Şifalı",
  flipbookTagPure: "Saf Miras",
  flipbookOilHoneyTitle: "Karakovan Balı & Soğuk Sıkım Zeytinyağı",
  flipbookOilHoneySubtitle: "Doğanın En Saf Şifası Tek Pakette",
  flipbookOilHoneyStory: "Muğla ve Kazdağları eteklerinden erken hasat soğuk sıkım zeytinyağı ile Siirt Pervari yüksek yaylalarının karakovan balı.",
  flipbookOilHoneyFeat1: "Asit Oranı < %0.3",
  flipbookOilHoneyFeat2: "Analiz Raporlu Ham Bal",
  flipbookOilHoneyFeat3: "Özel Koruyucu Ahşap Kutu",

  flipbookCatTreats: "Özel İkramlıklar",
  flipbookTagPalace: "Saray Geleneği",
  flipbookLokumTitle: "Çifte Kavrulmuş Antep Fıstıklı Lokum",
  flipbookLokumSubtitle: "Bakır Kazanlarda Odun Ateşinde Pişirildi",
  flipbookLokumStory: "Osmanlı saray mutfağının kadim formülüyle, taze nar özü ve çifte kavrulmuş iri Antep fıstıkları ile harmanlandı.",
  flipbookLokumFeat1: "Jelatinsiz & Glutensiz",
  flipbookLokumFeat2: "Bol Duble Fıstıklı",
  flipbookLokumFeat3: "Özel Hediye Kutusunda"
};
